import { combineReducers } from 'redux'

import { commonReducer } from 'root-redux/reducers/common'
import { userReducer } from 'root-redux/reducers/user'

import { paymentReducer } from 'modules/purchase/redux/reducers/common'
import { accountReducer } from 'modules/registration/redux/reducer'

import { IAppState } from 'models/store.model'

export const rootReducer = combineReducers<IAppState>({
  common: commonReducer,
  user: userReducer,
  payment: paymentReducer,
  account: accountReducer,
})
